import { render, staticRenderFns } from "./TeamOverview.vue?vue&type=template&id=0df2691d&"
import script from "./TeamOverview.vue?vue&type=script&lang=js&"
export * from "./TeamOverview.vue?vue&type=script&lang=js&"
import style0 from "./TeamOverview.vue?vue&type=style&index=0&id=0df2691d&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports